import { FC, useEffect, useMemo, useState } from 'react';
import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';

import { FormSearchableSelect, FormSwitch, FormTextField } from '../../../../../lib/components';
import { CompanyForm, CompanyFormProps } from '../../shared/companyForm';
import { KeyofNamespace } from '../../../../../translations/keyofNs';
import Util from '../../../../../misc/util';
import { countryOptions } from '../../../../../misc/countries';

type Props = Omit<CompanyFormProps, 'children'>;

export const PaymentDataAddressForm: FC<Props> = (props) => {
  const { t, i18n } = useTranslation();

  const [isEqual, setIsEqual] = useState<boolean>(false);

  const language = i18n.resolvedLanguage;
  const countryNames = useMemo(() => countryOptions(language), [language]);

  useEffect(() => {
    setIsEqual(props.initialValues?.equal);
  }, []);

  return (
    <CompanyForm {...props}>
      <>
        <FormSwitch
          key="equal"
          label={t('payment:equal_address')}
          name={'equal'}
          checked={props.initialValues?.equal}
          value={props.initialValues?.equal}
          onChangeCapture={() => setIsEqual(!isEqual)}
        />
        {Object.keys(
          typeof props.initialValues?.address === 'object' && props.initialValues.address
        ).map((key, index) =>
          ['province', 'country'].includes(key) ? (
            <FormSearchableSelect
              key={index}
              label={t(`payment:${key}` as KeyofNamespace<'payment'>)}
              placeholder={t(`payment:${key}` as KeyofNamespace<'payment'>)}
              name={`address.${key}`}
              options={key === 'country' ? countryNames : Util.provinceNames}
              xs={6}
              disabled={isEqual}
            />
          ) : (
            <FormTextField
              key={index}
              label={t(`payment:${key}` as KeyofNamespace<'payment'>)}
              placeholder={t(`payment:${key}` as KeyofNamespace<'payment'>)}
              name={`address.${key}`}
              validation={Yup.string().nullable()}
              xs={6}
              disabled={isEqual}
            />
          )
        )}
      </>
    </CompanyForm>
  );
};
